import { IBaseModel, BaseModel } from '../base.model';
import { AppointmentTypes } from '../../common/enums';
import { IAppointmentListing } from './appointment-listing.model';
import { TYPE_APPOINTMENT_COLOR, TYPE_EVENT_COLOR, TYPE_APPOINTMENT_DRAFT_COLOR, TYPE_APPOINTMENT_FINISHED_COLOR } from '../../common/constants';
import * as moment from 'moment';
import { Moment } from 'moment';
export interface IAppointmentListingViewModel extends IBaseModel {
  title?: string;
  start?: Moment;
  end?: Moment;
  description?: string;
  originId?: string;
  fk_block?: number;
  block?: { name: string };
  actions?: any[]
  ticketId?: string
  blockName?: string;
  ics?: Array<{ firstname: string; lastname: string; email: string }>
}

export class AppointmentListingViewModel extends BaseModel implements IAppointmentListingViewModel {
  /**
   *
   */
  block?: { name: string };
  title?: string;
  start?: Moment;
  end?: Moment;
  description?: string;
  originId?: string;
  fk_block: number;
  blockName?: string;
  ics: Array<{ firstname: string; lastname: string; email: string; }>

  backgroundColor: string;
  borderColor: string;
  className: string;
  appointment_state: string;
  type?: string;
  actions?: any[]
  ticketId?: string
  getBackgroundColor(id: number, type: AppointmentTypes) {

    if (type === AppointmentTypes.Event) {
      this.backgroundColor = TYPE_EVENT_COLOR;
      this.borderColor = TYPE_APPOINTMENT_COLOR;
      this.className += ' secondary ' + type;
    }
    else if (type === AppointmentTypes.Appointment) {
      if (this.appointment_state === 'draft') {
        this.backgroundColor = TYPE_APPOINTMENT_DRAFT_COLOR;
        this.borderColor = 'white';
        this.className += 'apppointment--draft' + type
      } else {
        if (this.appointment_state === 'finished') {
          this.backgroundColor = TYPE_APPOINTMENT_FINISHED_COLOR;
        } else {
          this.backgroundColor = TYPE_APPOINTMENT_COLOR;
        }
        this.className += ` primary ${type} ${this.appointment_state}`;
        this.borderColor = TYPE_EVENT_COLOR;
      }
    }
  }

  getClassName(id: number, type: AppointmentTypes) {
    this.className = `${type === AppointmentTypes.Event ? 'secondary ' : 'primary '} event-custom${id}`;
    return;
  }
  constructor(opt?: IAppointmentListing) {

    super();

    if (opt.actions && opt.actions.length > 0) {
      this.ticketId = opt.actions[0].channel.fk_channel_ticket;
    }

    this.title = opt.name;
    this.className = 'event-class-' + opt.id;
    this.originId = opt.id.toString();
    this.description = opt.description;
    this.type = opt.type;
    this.appointment_state = opt.appointment_state || 'confirmed';
    this.start = moment.utc(opt.start_date);
    this.end = moment.utc(opt.end_date);
    
    if (opt['block']) {
      this.fk_block = opt.fk_block
      this.blockName = opt.block.name
    }
    if (opt['independent_contractors']) {
      this.ics = opt.independent_contractors.map(x => {
        return {
          firstname: x.firstname,
          lastname: x.lastname,
          email: x.email,
          cellphone: x.cellphone,
          avatar: `${(x.firstname || '').substring(0, 1)}${(x.lastname || '').substring(0, 1)}`
        }
      })
    }
    this.getBackgroundColor(opt.id, opt.type);
  }
}


// WEBPACK FOOTER //
// ./src/models/appointment/appointment-listing.viewmodel.ts